import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { persistStore } from 'redux-persist';

// Import API services
import { baseApi } from './api/baseApi';

// Import slices
import userSlice from './slices/user.slice';
import configSlice from './slices/config.slice';
import riskAssessmentSlice from './slices/riskAssessment.slice';
import apiHistoryReducer from './slices/apiHistory.slice';

// Import API services that extend baseApi
// Note: These APIs use baseApi.injectEndpoints(), so they share the same reducer and middleware
import { authApi } from './api/auth.apislice';
// import { usersApi } from './api/usersApi';
// import { transactionsApi } from './api/transactionsApi';

// Combine reducers (persistence is handled per-slice)
const rootReducer = combineReducers({
  // Add your reducers here
  user: userSlice, // Already persisted in slice
  config: configSlice,
  riskAssessment: riskAssessmentSlice,
  apiHistory: apiHistoryReducer,

  // Add API reducer - all injected endpoints share this single reducer
  [baseApi.reducerPath]: baseApi.reducer,
});

// Configure store
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(baseApi.middleware),
  
  devTools: true,
});

// Create persistor
export const persistor = persistStore(store);

// Setup listeners for RTK Query
export const setupStore = () => {
  // Set up listeners for RTK Query
  setupListeners(store.dispatch);
};

export default store;
